export default __webpack_public_path__ + "static/media/restaurantReception.cdd57759.svg";